var React = require( 'react' );
var createReactClass = require('create-react-class');

var DropDownListItem = createReactClass({
  render: function(){
    return (
      <option value={this.props.listItem.value}>{this.props.listItem.title}</option>
    )
  }
});

module.exports = DropDownListItem;



// WEBPACK FOOTER //
// ./src/common/routes/components/dropDownListItem.jsx